import React from "react";
import { useSharedSelector } from "../../store/SharedProvider";
import { selectIsReadOnly } from "../../store/app-configurations/app-configurations-selectors";
import WebAppNavigationRoutes from "../../enums/query-params/webapp-navigation-routes";

interface IReadOnlyProtectedFormProps extends React.HTMLProps<HTMLFormElement> {
  forceReadOnly?: boolean;
}

const ReadOnlyProtectedForm: React.FC<IReadOnlyProtectedFormProps> = ({forceReadOnly, ...props}) => {
  const isReadOnly = useSharedSelector((state) => selectIsReadOnly(state));

  const isServiceSite = window.location.pathname.startsWith(WebAppNavigationRoutes.routeCommissioningBase);
  const forcedIsReadOnly = (forceReadOnly !== undefined && forceReadOnly) || (isReadOnly && !isServiceSite);

  return (
    <form
      {...props}
      style={{
        ...props.style,
        opacity: forcedIsReadOnly ? 0.75 : 1,
        pointerEvents: forcedIsReadOnly ? "none" : "initial",
      }}
    >
      <fieldset disabled={forcedIsReadOnly} style={{ border: "none", minWidth: 0, padding: 0 }}>
        {props.children}
      </fieldset>
    </form>
  );
};

export default ReadOnlyProtectedForm;
